import useCarouselState from '@/app/(site)/(static)/about/sections/values/hooks/use-carousel-state'
import { cn } from '@/util/cn'
import { HTMLAttributes } from 'react'
import SlideComponent from '../slide'
import SlideMobileNavigation from '../slide-mobile-navigation'
import MobileNavigationList from '../mobile-navigation-list'

type Props = {
    state: ReturnType<typeof useCarouselState>
} & HTMLAttributes<HTMLDivElement>

const MobileLayout = ({ state, className, ...rest }: Props) => {
    return (
        <div className="grid gap-3">
            <MobileNavigationList state={state} />
            
            <div className={cn('grid bg-giphyDarkestGrey rounded-xl min-h-[27rem] md:min-h-[39rem]', className)} {...rest}>
                <SlideComponent
                    {...state.activeSlide}
                    animationHandlers={state.animationHandlers}
                    classNames={{
                        content: 'place-items-center'
                    }}
                    renderName={name => (
                        <SlideMobileNavigation name={name} isDisabled={state.isAnimating} onNext={state.goToNextSlide} onPrev={state.goToPrevSlide} />
                    )}
                />
            </div>
        </div>
    )
}

export default MobileLayout
